import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { compose } from 'recompose';
import { withRouter } from 'react-router-dom';
import { graphql } from 'react-apollo';

import LoadingDataEnhancer from './LoadingData';
import withPagination from './WithPagination';

import featureFlagQuery from '../graphql/featureFlagQuery';
import updateFeatureFlagMutation from '../graphql/updateFeatureFlagMutation';
import FeatureFlagList from '../views/FeatureFlag/List';

class FeatureFlag extends Component {
  constructor(props) {
    super(props);
    this.state = {
      featureFlag: false,
      setID: '',
    };
  }

  render() {
    const {
      updateFeatureFlag,
      data,
      data: { featureFlags },
    } = this.props;
    const onCheckboxHandler = id => (event, eventData) => {
      const input = {
        featureFlag: { id: parseInt(id, 10), checked: eventData.checked },
      };

      updateFeatureFlag({
        variables: { input },
      }).then(({ data: responseData }) => {
        const {
          updateFeatureFlag: { success },
        } = responseData;
        if (success) {
          data.refetch();
          this.setState({ featureFlag: eventData.checked, setID: id });
          window.location.reload();
        }
      });
    };
    const { featureFlag, setID } = this.state;

    return (
      <div>
        <FeatureFlagList
          featureFlagList={featureFlags}
          checkboxHandler={onCheckboxHandler}
          featureFlag={featureFlag}
          setID={setID}
        />
      </div>
    );
  }
}

FeatureFlag.propTypes = {
  updateFeatureFlag: PropTypes.func.isRequired,
  data: PropTypes.shape({
    refetch: PropTypes.func.isRequired,
    featureFlags: PropTypes.array.isRequired,
  }).isRequired,
};

export default compose(
  withRouter,
  withPagination(featureFlagQuery, 'featureFlags'),
  graphql(updateFeatureFlagMutation, { name: 'updateFeatureFlag' }),
  LoadingDataEnhancer
)(FeatureFlag);
